/* SA: AI Models — animated data "comet" pulses along the flow-chart connectors.
   Each travelling pulse is built from stacked layers (bright thick head -> faint thin
   tail) so it reads as a tapering, colour-graded comet.
   (The CraftNet module border is animated separately, in CSS.) */
(function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';

  // Connector pulses (kept slow).
  var LINE_SPEED = 90; // user-units per second
  var LINE_SEG = 8;
  // Densely-spaced, overlapping layers (lead step 4 < LINE_SEG 8) so the comet reads
  // as ONE continuous gradient streak that fades head -> tail, instead of a few
  // separate dashes/dots with gaps between them.
  var LINE_LAYERS = [
    { lead: 0,  width: 3.2, opacity: 1.0, head: true },
    { lead: 4,  width: 3.0, opacity: 0.78 },
    { lead: 8,  width: 2.7, opacity: 0.6 },
    { lead: 12, width: 2.4, opacity: 0.46 },
    { lead: 16, width: 2.1, opacity: 0.34 },
    { lead: 20, width: 1.8, opacity: 0.25 },
    { lead: 24, width: 1.5, opacity: 0.18 },
    { lead: 28, width: 1.2, opacity: 0.12 },
    { lead: 32, width: 0.9, opacity: 0.07 },
    { lead: 36, width: 0.7, opacity: 0.04 }
  ];

  function buildComet(path, opts, group, delayFrac) {
    var len = 0;
    try { len = path.getTotalLength(); } catch (e) { return []; }
    if (!len) return [];

    var d = path.getAttribute('data-pulse-d') || path.getAttribute('d');
    var period = opts.seg + len; // one seamless lap
    var duration = (period / opts.speed) * 1000;
    var delay = -duration * (delayFrac || 0);
    var made = [];

    opts.layers.forEach(function (layer) {
      var p = document.createElementNS(SVG_NS, 'path');
      var cls = 'sa-ai-models__pulse';
      if (layer.head) cls += ' sa-ai-models__pulse--head';
      p.setAttribute('class', cls);
      p.setAttribute('d', d);
      p.style.stroke = opts.color;
      p.style.strokeWidth = layer.width;
      p.style.strokeOpacity = layer.opacity;
      p.style.strokeDasharray = opts.seg + ' ' + len;
      group.appendChild(p);

      if (typeof p.animate !== 'function') return;
      made.push(p.animate(
        [
          { strokeDashoffset: opts.seg + layer.lead },
          { strokeDashoffset: layer.lead - len }
        ],
        { duration: duration, iterations: Infinity, easing: 'linear', delay: delay }
      ));
    });
    return made;
  }

  function initDiagram(root) {
    if (!root || root.dataset.aimInit === '1') return;
    var svg = root.querySelector('.sa-ai-models__svg');
    if (!svg) return;

    root.dataset.aimInit = '1';
    if (/Android/i.test(navigator.userAgent || '')) {
      root.setAttribute('data-aim-static-labels', '');
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var lines = Array.prototype.slice.call(svg.querySelectorAll('.sa-ai-models__line[data-flow]'));
    if (!lines.length) return;

    var group = document.createElementNS(SVG_NS, 'g');
    group.setAttribute('class', 'sa-ai-models__pulses');
    var firstArrow = svg.querySelector('.sa-ai-models__arrow');
    if (firstArrow) {
      svg.insertBefore(group, firstArrow);
    } else {
      svg.appendChild(group);
    }

    var anims = [];

    lines.forEach(function (line, i) {
      var accent = line.hasAttribute('data-accent');
      var speed = Number(line.getAttribute('data-flow-speed')) || LINE_SPEED;
      anims = anims.concat(buildComet(line, {
        color: accent ? '#bfe3ff' : '#ffffff',
        seg: LINE_SEG, speed: speed, layers: LINE_LAYERS
      }, group, i / lines.length));
    });

    if (!anims.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0] && entries[0].isIntersecting;
        anims.forEach(function (a) {
          try { visible ? a.play() : a.pause(); } catch (e) {}
        });
      }, { rootMargin: '120px' });
      io.observe(root);
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-sa-ai-models]');
    for (var i = 0; i < nodes.length; i++) initDiagram(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sa-ai-models]');
    if (root) initDiagram(root);
  });
})();
